import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GlobalPopupState {
  isOpen: boolean;
  imageUrl: string | null;
  linkUrl: string | null;
  linkTarget: string | null;
}

const initialState: GlobalPopupState = {
  isOpen: false,
  imageUrl: null,
  linkUrl: null,
  linkTarget: null,
};

export const globalPopupSlice = createSlice({
  name: "globalPopup",
  initialState,
  reducers: {
    openGlobalPopup: (
      state,
      action: PayloadAction<{
        imageUrl: string;
        linkUrl?: string | null;
        linkTarget?: string | null;
      }>,
    ) => {
      state.imageUrl = action.payload.imageUrl;
      state.linkUrl = action.payload.linkUrl || null;
      state.linkTarget = action.payload.linkTarget || null;
      state.isOpen = true;
    },
    closeGlobalPopup: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openGlobalPopup, closeGlobalPopup } = globalPopupSlice.actions;

export default globalPopupSlice.reducer;
